export default "__VITE_ASSET__ByBn2XOB__"